import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { actions as profileActions } from '@cinch/oxd-redux/profile/src'

import UnsaveButton from './unsave-button.component'

export const mapDispatchToProps = (dispatch: Dispatch, props: any) => ({
  onClick: () => dispatch(profileActions.removeFavourite(props.vehicleId)),
})

const Component: React.FC<any> = ({ onClick }) => <UnsaveButton onClick={onClick} />

export default connect(null, mapDispatchToProps)(Component)
